











import Vue from "vue";
import Sidebar from "../components/smartchronos/partials/Sidebar.vue";
import Navbar from "../components/smartchronos/partials/Navbar.vue";
import { Auth } from "../classes/Auth";
export default Vue.extend({
  name: "Smartchronos",
  components: {
    Sidebar,
    Navbar,
  },
  data: () => ({
    drawer: true,
    auth: new Auth(),
  }),
  methods: {
    toggleSidebar(event: any) {
      this.drawer = event;
    },
  },
});
